import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TokenService } from '../../../services';


import { LoginService } from "../../../services/login.service";

@Component({
  selector: "okta-widget",
  templateUrl: "./okta-widget.component.html",
  styleUrls: ["./okta-widget.component.css"]
})
export class OktaWidgetComponent implements OnInit {

  @Input()
  OktaAccessToken: string;

  @Input()
  OktaRefreshToken: string;

  constructor(private loginService: LoginService, private router: Router, private tokenService: TokenService,) {
  }

  ngOnInit() {
    const accessToken = this.tokenService.getAccessToken()
    if (!this.OktaAccessToken && accessToken) {
      const okta_auth_ApplicationName = this.loginService.getoktaAuthApplicationName();
      this.OktaAccessToken = okta_auth_ApplicationName ? "" : accessToken.accessToken;
    }
    this.loginService.setAccessCode(this.OktaAccessToken);
    const refreshToken = this.tokenService.getRefreshToken()
    if (!this.OktaRefreshToken && refreshToken) {
      const okta_auth_ApplicationName = this.loginService.getoktaAuthApplicationName();
      this.OktaRefreshToken = okta_auth_ApplicationName ? "" : refreshToken;
    }
    this.loginService.setRefreshCode(this.OktaRefreshToken);
    this.loginService.showWidGet();
  }
}